/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const PinOffIcon = ({ width = 24, height = 24, hidden = false, title = 'Pin Off' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M17.38086,6.56641l-3.94629-3.94629c-.3623-.36328-.8457-.5625-1.35938-.5625h-.00098c-.51465,0-.99902.20117-1.36035.56348-.4248.42383-.62109.99902-.55664,1.56445l-3.16504,3.16504-2.31152-.19824c-.74805-.08594-1.4375.30957-1.75977.98535-.32227.67773-.1875,1.45898.34375,1.99023l2.77344,2.77344-3.81836,3.81836c-.29297.29297-.29297.76758,0,1.06055.14648.14648.33789.21973.53027.21973s.38379-.07324.53027-.21973l3.81836-3.81836,2.77441,2.77441c.33887.33984.78027.5166,1.23145.5166.25488,0,.5127-.05664.75781-.17285.67676-.32227,1.06348-1.0127.98633-1.74609l-.2002-2.32617,3.16602-3.16602c.56738.06738,1.14062-.12988,1.56445-.55371.36328-.36328.56348-.8457.56445-1.35938.00098-.51562-.19922-.99902-.5625-1.3623ZM16.31836,8.22754c-.12695.12598-.28809.15918-.4375.0957-.28125-.12402-.60938-.05957-.82715.1582l-3.71289,3.71289c-.15625.15625-.23633.37402-.2168.59473l.23145,2.6875c.01562.14453-.06738.21484-.13867.24902-.07227.03516-.18066.05273-.2832-.0498l-6.6084-6.6084c-.10352-.10352-.08496-.21191-.0498-.28418.03125-.06543.09277-.13965.22363-.13965.0127,0,.02539.00098.03906.00195l2.67285.22949c.22168.02051.4375-.05957.59473-.2168l3.71191-3.71191c.2168-.2168.28027-.54492.1582-.82715-.06543-.15332-.03125-.30762.09863-.4375.08008-.08008.18652-.12402.30078-.12402.11328,0,.21973.04395.29883.12305l3.94629,3.94629c.16504.16504.16406.43457-.00195.60059Z"
      fill="currentColor"
    />
  </svg>`;
};
